import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';
import React from 'react';

export const ProtectedRoute = ({ children }) => {
    console.log('ProtectedRoute check - starting');
    const isAuth = authService.isAuthenticated();
    
    // If not authenticated at all, redirect to login
    if (!isAuth) {
        console.log('ProtectedRoute - redirecting to login');
        return <Navigate to="/" replace />;
    }
    
    // Special check for parent users: if they're authenticated but haven't selected a team,
    // redirect them to team selection page
    const userType = sessionStorage.getItem('user_type');
    const isParent = userType === 'parent';
    const hasSelectedTeam = !!sessionStorage.getItem('selected_team_id');
    const currentPath = window.location.pathname;
    
    // Fix: Check if we're already on the team selection page or any related path
    const isOnTeamSelectionPage = currentPath === '/team-selection' || 
                                currentPath === '/team-selection/' || 
                                currentPath.startsWith('/team-selection');
    
    if (isParent && !hasSelectedTeam && !isOnTeamSelectionPage) {
        console.log('ProtectedRoute - parent user without team selection, redirecting to team selection');
        return <Navigate to="/team-selection" replace />;
    }

    return (
        <>
            {children}
        </>
    );
}; 